import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import WPErrorFullPage from "../../packages/WPErrorFullPage/WPErrorFullPage";
import WPLoader from "../../packages/WPLoader";

import Header from "../../components/Header";
import LicensedDocumentation from "../../components/LicensedDocumentation";

import { HTTP_STATUS_CODE } from "../../constants/apiResponseCode.constants";

import Footer from "../../common/footer/Footer";

import { hasLicensedDocumentationAccess } from "../../utils/LicenseUtils";

const DocumentationPage = () => {
  useTranslation();
  const userProfileData = useSelector((state) => state.userProfileData);
  const userLicenses = useSelector((state) => state.userLicenses || []);

  const isCheckingDocumentationAccess = userProfileData == null;

  const canAccessDocumentation = useMemo(
    () => hasLicensedDocumentationAccess(userLicenses),
    [userLicenses],
  );

  if (isCheckingDocumentationAccess) {
    return <WPLoader />;
  }

  if (!canAccessDocumentation) {
    return <WPErrorFullPage errorCode={HTTP_STATUS_CODE.FORBIDDEN} />;
  }

  return (
    <div className="container-main">
      <Header disableActions={isCheckingDocumentationAccess} />
      <div className="main-container">
        <div
          className="content-container"
          style={
            !isCheckingDocumentationAccess
              ? { paddingTop: "0px", paddingBottom: "0px" }
              : {}
          }
        >
          <LicensedDocumentation userLicenses={userLicenses} />
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default DocumentationPage;
